import styled from "styled-components";
import { InnerProgress, ProgressBar } from "@/pages/profile/components/atom";

export const MemberSystemWrapper = styled.div`
  width: 100%;
  height: 100%;
`;
export const UserNameIcon = styled.div`
  width: 40px;
  height: 40px;
  line-height: 42px;
  font-weight: 600;
  font-size: 30px;
  text-align: center;
  color: #ffffff;
  background: var(--task-user-icon-background);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserName = styled.div`
  color: #edf7fa;
  font-weight: 600;
  font-size: 18px;
`;

export const VertifyLink = styled.button`
  all: unset;
  color: #795723;
  font-weight: 600;
  cursor: pointer;
  background: linear-gradient(261.59deg, #ffbe83 0%, #fff4d8 100%);
  border-radius: 2px;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
`;

export const LevelCard = styled.div`
  margin: 14px 0;
  position: relative;
  img {
    width: 298px;
  }
`;

export const NextLevelContent = styled.div`
  background: #27292d;
  width: 100%;
  padding: 16px;
  border-radius: 8px;
`;

export const NextLevelText = styled.div`
  margin-top: 4px;
  font-size: 12px;
  .vip {
    font-weight: 600;
  }
`;

export const BalanceTextContent = styled.div`
  background: #27292d;
  width: 100%;
  padding: 9px 0;
  border-radius: 9px 16px;
  margin-top: 8px;
  display: flex;
`;

export const BalanceText = styled.div`
  width: 50%;
  font-size: 12px;
  padding: 0 15px;
  p {
    margin: 0;
    color: rgba(255, 255, 255, 0.9);
  }
  .tooltip-wrapper {
    width: 100%;
    align-items: baseline;
  }
  .symbol {
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
  }
  .credit {
    font-size: 22px;
    font-weight: 500;
    margin-left: 2px;
    color: rgba(255, 255, 255, 1);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &.border-left {
    position: relative;
    padding-left: 17px;
    ::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      margin: auto 0;
      width: 1px;
      height: 32px;
      background: #54585f;
    }
  }
`;

export const CurrentProgress = styled(InnerProgress)`
  background: ${(p) => p.color};
`;
export const MemberProgressBar = styled(ProgressBar)`
  flex: 1;
  margin-top: 0;
  background: rgba(31, 33, 37, 1);
`;
